/*-----------------------------------------------------------------
- Auth routes
-----------------------------------------------------------------*/
const prefix: string = 'auth';

const routes = [
    {
        path     : `${prefix}/login`,
        name     : `${prefix}-login`,
        component: () => import('@/modules/auth/views/Login.vue'),
        meta     : {
            guest : true,
            layout: 'auth',
        },
    },
    {
        path     : `${prefix}/register`,
        name     : `${prefix}-register`,
        component: () => import('@/modules/auth/views/Register.vue'),
        meta     : {
            guest : true,
            layout: 'auth',
        },
    },
    {
        path     : `${prefix}/forget`,
        name     : `${prefix}-forget`,
        component: () => import('@/modules/auth/views/Forget.vue'),
        meta     : {
            guest : true,
            layout: 'auth',
        },
    },
];

export default routes;
